import { Pueblo } from './../../models/pueblo.model';
import { PuebloTabsPage } from './../pueblo-tabs/pueblo-tabs';
import { SubCategoria } from './../../models/subcategoria.model';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController, Content, App, ToastController, ModalController } from 'ionic-angular';
import { Consultas } from '../../providers/consultas';
import { ListaEmpresas } from '../lista-empresas/lista-empresas';
import 'rxjs/add/observable/merge';
import { VariablesGlobales } from '../../providers/variables-globales';
import { Categoria } from '../../models/categoria.model';
import { BuscadorPage } from '../buscador/buscador';
import { BarrioModel } from '../../models/barrio.model';
import { BarriosPage } from '../lista-barrios/lista-barrios';
@Component({
  selector: 'page-lista-categorias',
  templateUrl: 'lista-categorias.html',
  providers: [ Consultas ]
})
export class ListaCategorias {
  @ViewChild(Content) content: Content;

   public categoriasYSubCategorias: Array<Categoria>;
   public loader: any;
   public pueblo:Pueblo;
   public tamañoElementosAbiertosAnterior:number;
   public idBarrio: number;
   public barrios:Array<BarrioModel>;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    private app: App,
    private toastCtrl:ToastController,
    public modalCtrl: ModalController) {
      this.pueblo = this.navParams.data as Pueblo;
      this.idBarrio = this.navParams.get("idBarrio");

      this.categoriasYSubCategorias = new Array<Categoria>();

    console.log('constructor');
  }

  goToListaEmpresas(subcategoria){
    this.app.getRootNav().push(ListaEmpresas,{idSubCategoria: subcategoria.id_subcategoria, idCiudad: this.pueblo.id_ciudad,nombreCategoria: subcategoria.nombre });
  }

  goToBarrios(){
    const modal = this.modalCtrl.create(BarriosPage,{idCiudad: this.pueblo.id_ciudad,nombrePueblo: this.pueblo.nombre});
    modal.present();
    modal.onDidDismiss((idBarrio)=>{
      let catYSub = new Array<Categoria>();
      if(idBarrio){
        this.consultas.getCategoriasYSubCategoriasByIdBarrio(idBarrio, this.pueblo.id_ciudad).subscribe(
          data  => {
            catYSub = this.procesarCategorias(data);
          },
          error => {
            console.log(error);
            this.loader.dismiss();
          },
          ()    => {
            this.categoriasYSubCategorias = catYSub;
            this.loader.dismiss();
          }
        );
      }else{
        this.cargaCategorias();
      }
    })
    //this.app.getRootNav().push(BarriosPage,{idCiudad: this.pueblo.id_ciudad,nombrePueblo: this.pueblo.nombre});
  }

  ngOnInit() {

    console.log("id_cidad "+this.pueblo.id_ciudad);
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
      this.cargaBarrios();
      this.cargaCategorias();
    });
  }

  cargaBarrios(){
    this.consultas.getBarriosByCiudad(this.pueblo.id_ciudad).subscribe(x=>
      {
        console.log(x);
        this.barrios = x;
      },error=>{
        console.error(error)
        this.loader.dismiss();
      }
      );
  }

  cargaCategorias(){
    let catYSub = new Array<Categoria>();
    this.consultas.getCategoriasYSubCategorias(this.pueblo.id_ciudad).subscribe(
        data  => {
          catYSub = this.procesarCategorias(data);
        },
        error => {
          console.log(error);
          this.loader.dismiss();
        },
        ()    => {
          this.categoriasYSubCategorias = catYSub;
          this.loader.dismiss();
        }
    );
  }

  procesarCategorias(data){
    let catYSub = new Array<Categoria>();

    if(data.length==0){
      let toast = this.toastCtrl.create({
        message: 'No hay empresas de este pueblo',
        duration: 3000,
        position: 'bottom'
      });

      toast.onDidDismiss(() => {
        console.log('Dismissed toast');
      });

      toast.present();

      this.app.getRootNav().push(PuebloTabsPage, {tabIndex: 2,pueblo:this.pueblo});

      return;
    }
    //console.log("data");
    //console.log(data);
    let indice = 0;
    let fila;
    data.forEach(
      function(categoriaYSubcategoria){
        if(indice%2==0)
        {
          fila = categoriaYSubcategoria[0] as Categoria;
          fila.subCategorias = new Array<SubCategoria>();

        }else
        {
          categoriaYSubcategoria.forEach(x=>{
            let subCategoria = x as SubCategoria;
            if(fila)
              fila.subCategorias.push(subCategoria);
          });
          if(categoriaYSubcategoria.length >0)
            catYSub.push(fila);
        }

      indice++;
    });
    return catYSub;
  }

  ionViewDidLoad() {

  }
  expandCategoria(item,element){
    console.log(element);
    this.categoriasYSubCategorias.map((categoria) => {
        if(item == categoria){
          categoria.expanded = !categoria.expanded;
          var rect = element.target.getBoundingClientRect();

          this.content.scrollTo(0,element.target.offsetParent.offsetTop,300);
        } else {
          categoria.expanded = false;
        }
        //console.log(categoria);
        return categoria;

    });

  }

  getPosition(el) {

    var yPosition = 0;

    while (el) {
      if (el.tagName == "BODY") {
        var yScrollPos = el.scrollTop || document.documentElement.scrollTop;
        yPosition += (el.offsetTop - yScrollPos + el.clientTop);
      } else {
        yPosition += (el.offsetTop - el.scrollTop + el.clientTop);
      }

      el = el.offsetParent;
    }
    return  yPosition;

  }


}



// WEBPACK FOOTER //
// ./src/pages/lista-categorias/lista-categorias.ts